export const REQUEST = 'manufacturer/REQUEST';
export const FAILURE = 'manufacturer/FAILURE';

export const GET_MANUFACTORERS_SUCCESS = 'manufacturer/GET_MANUFACTORERS_SUCCESS';
export const GET_PRICE_MANUFACTORERS_SUCCESS = 'manufacturer/GET_PRICE_MANUFACTORERS_SUCCESS';
export const SEND_CONTACT_REQUEST_SUCCESS = 'manufacturer/SEND_CONTACT_REQUEST_SUCCESS';
export const BECOME_MANUFACTURER_REQUEST_SUCCESS = 'manufacturer/BECOME_MANUFACTURER_REQUEST_SUCCESS';
